import React from 'react';
import { Box, CircularProgress, Alert } from '@mui/material';
import { useVehicles } from '../../hooks/useVehicles';
import VehiclesDashboard from '../../components/administracion/VehiclesDashboard';

const VehiculosPage = () => {
  const { vehicles, error, isLoading } = useVehicles();

  if (isLoading) return <CircularProgress />;
  if (error) return <Alert severity="error">Error al cargar vehiculos.</Alert>;

  return (
    <Box sx={{ p: 2 }}>
      <VehiclesDashboard
        windows={vehicles}
        onReorder={(newOrder) => {
          console.log('Nuevo orden de vehiculos:', newOrder);
        }}
      />
    </Box>
  );
};

export default VehiculosPage;